<template>
    <div class="action" v-if="loaded">
        <ErrorBoundary :fall-back="fallBack">
          <hero :data="hero" :has-info="hasInfo"></hero>
        </ErrorBoundary>
        <div class="container">
            <ErrorBoundary :fall-back="fallBack">
                <ListGoals :goals="goals" v-if="goals.length > 0 && cause.has_communal_goal"/>
            </ErrorBoundary>

            <ErrorBoundary :fall-back="fallBack">
              <div class="container--block align-center mt-4 mb-2">
                <h3 class="m-0 color__text--primary">{{cause.summary}}</h3>
                <p class="m-1 description__text" v-html="cause.description"></p>
              </div>
            </ErrorBoundary>

            <ErrorBoundary :fall-back="fallBack">
              <List :data="categories" :options="filters" kind="action" type="cat" />
            </ErrorBoundary>
        </div>
    </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { ErrorBoundary } from 'vue-error-boundary';
  import { log } from "../utilities/log";

  import Fallback from '../components/common/Fallback';
  import Hero from '../components/Hero';
  import List from '../components/main/List';
  import ListGoals from "../components/main/ListGoals";

  export default {
    name: 'Action',

    components: {
      ErrorBoundary,
      Hero,
      List,
      ListGoals
    },

    data: () => {
      return {
        fallBack: Fallback,
        hasInfo: false,
        loaded: false
      }
    },

    computed: {
      ...mapState({
        causes: state => state.causes,
        categories: state => state.categories,
        content: state => state.content,
        goals: state => state.goals,
        prayerGroups: state => state.prayerGroups,
      }),
      filters: function() {
        return [ this.prayerGroups ];
      },
      cause: function() {
        return this.causes.filter((cause) => cause.id === this.$route.params.cause_id)[0];
      },
      hero: function() {
        return {
          type: 'subpage', //main, subpage
          title: this.cause.name,
          icon: this.cause.raisesouls_icon_url,
          background: this.content.background
        }
      }
    },

    beforeMount: async function () {
      try {
        await this.$store.dispatch('updateCategoriesMount', { cause: this.cause, type: 'action', id: 'categories' }, { root: true });
        this.loaded = true;
      } catch (err) { log(`Error Mounting Initial Action Items: ${err.message}`, 'error'); }
    }
  }
</script>
